// 错误码判断
// @desc 错误码判断文件
// @author ss
// @date 随时更新
// @example this.$err.errcode(code码)
import $zj from "@/assets/js/training";
import router from '@/router';
export default {
    errcode(code, error) {
        switch (code) {
            case 200:
                break;
            case 14003:
                break;
            case 902:
                break;
            case 925:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "证书已申请"
                })
                break;
            case 6201:
              break;
            case 6202:
              break;
            case 6427:
              break;
            case 6422:
              break;
            case 6418:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "课程已被替换",
                    BACK_SUBMIT: () => {
                       router.go(-1);
                    },

                })

            break;
            case 2560:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您的订单已进入线下支付流程，无法取消线下支付',
                })
                break;
            case 3534:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '未查询到用户计划信息',
                    BACK_SUBMIT: () => {
                        router.go(-1)
                    }
                })
                break;
            case 2538:
                $zj.alert({
                    CONTENT: "由于您所在的地区课程发生了变化，全部课程已从购物车移除。",
                    BACK_SUBMIT: () => {
                       router.go(-1);
                    },
                    SHOW_CANCEL: false
                })
                break;
            case 926:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "成绩不合格"
                })
                break;
            case 1505:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试卡模板不存在"
                })
                break;
            case 1506:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试卡不存在"
                })
                break;
            case 2505:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "购物车已经存在此课程"
                })
                break;
            case 887:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "手机号重复",
                })
                break;

            case 1005:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "身份证号格式错误",
                })
                break;

            case 1006:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "手机号格式错误",
                })
                break;

            case 1007:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "手机号与此账号不匹配",
                })
                break;

            case 1008:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "邮箱与此账号不匹配",
                })
                break;

            case 1356:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "此身份证已注册",
                })
                break;

            case 1358:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "邮箱格式有误",
                })
                break;

            case 1359:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "此手机号码已注册,请更换其他手机号码",
                })
                break;

            case 1360:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "手机号格式有误",
                })
                break;

            case 1361:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "验证码未验证",
                })
                break;

            case 1362:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "姓名格式有误",
                })
                break;

            case 3005:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "找不到此用户",
                })
                break;

            case 7001:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "身份证或密码错误，请重试",
                })
                break;
            case 7002:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "用户被冻结",
                })
                break;

            case 7003:
                if (localStorage.getItem("token")) {
                    if (router.history.current.path != "/homeIndex") {
                        try {
                            var de = document;
                            if (de.exitFullscreen) {
                                de.exitFullscreen();
                            } else if (de.mozCancelFullScreen) {
                                de.mozCancelFullScreen();
                            } else if (de.webkitCancelFullScreen) {
                                de.webkitCancelFullScreen();
                            }
                            document.querySelector("video").pause()
                        } catch (error) {

                        }
                        if(router.history.current.path == '/courseDetails'){
                            $zj.alert({
                                TITLE: "提示",
                                CONTENT: "登录已失效",
                                BACK_SUBMIT: () => {
                                    router.push({ path: "/login?needback=1" });
                                }
                            })
                        }else{
                            $zj.alert({
                                TITLE: "提示",
                                CONTENT: "登录已失效",
                                BACK_SUBMIT: () => {
                                    router.replace({ path: "/login" });
                                }
                            })
                        }
                    }
                } else {

                    if(router.history.current.path == '/courseDetails'){
                        $zj.alert({
                            TITLE: "提示",
                            CONTENT: "请登录",
                            BACK_SUBMIT: () => {
                                router.push({ path: "/login?needback=1" });
                            }
                        })
                    }else{
                        $zj.alert({
                            TITLE: "提示",
                            CONTENT: "请登录",
                            BACK_SUBMIT: () => {
                                router.replace({ path: "/login" });
                            }
                        })
                    }
                }
                localStorage.removeItem("token");
                break;
            case 7004:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "旧密码错误",
                })
                break;

            case 7005:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "找不到此用户",
                })
                break;

            case 7006:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "验证码错误",
                })
                break;

            case 7007:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "新密码和确认密码不一致",
                })
                break;

            case 7008:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "验证码无效",
                })
                break;

            case 7009:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "身份证或密码错误,请重试",
                })
                break;

            case 7010:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "身份证或密码错误,请重试",
                })
                break;
                // case 7026:
                //     $zj.alert({
                //         TITLE: "提示",
                //         SHOW_CLOSE: false,
                //         SHOW_CANCEL: false,
                //         BTN_SUBMIT: "确定",
                //         CONTENT: "根据湖南省事业单位工作人员培训相关规定，您需要先到管理平台hnxxpt.zgzjzj.net进行注册再进行选课学习，您目前未在管理平台注册，您的学习信息将无法用于学时认定，请您先完成管理平台注册。",
                //         BACK_SUBMIT: () => {

                //         }
                //     })
                //     break;
                case 7028:
                    $zj.alert({
                        TITLE: "提示",
                        SHOW_CLOSE: false,
                        SHOW_CANCEL: false,
                        BTN_SUBMIT: "关闭",
                        CONTENT: "账号或密码错误，如您未在培训平台修改过密码，你可尝试使用您的身份证号后六位（末位为X时为大写字母）作为密码进行登录，如果您已在培训平台修改过登录密码，请您联系客服为您重置密码。客服电话400-843-4678。。",
                        BACK_SUBMIT: () => {

                        }
                    })
                    break;
                // case 7027:
                //     $zj.alert({
                //         TITLE: "提示",
                //         SHOW_CLOSE: false,
                //         SHOW_CANCEL: false,
                //         BTN_SUBMIT: "确定",
                //         CONTENT: "根据湖南省事业单位工作人员培训相关规定，为保证您的培训学时可以正常出具证书，您需要先使用电脑进入网址hnxxpt.zgzjzj.net进行登录后，点击培训入口中“北京思想天下教育科技有限公司”入口图片进行一次跳转，以完成账号信息同步，完成同步后您即可直接在“北京思想天下教育科技有限公司”培训平台登录。",
                //         BACK_SUBMIT: () => {

                //         }
                //     })
                //     break;
                // case 7029:
                //     $zj.alert({
                //         TITLE: "提示",
                //         SHOW_CLOSE: false,
                //         SHOW_CANCEL: false,
                //         BTN_SUBMIT: "确定",
                //         BTN_CANCEL: "关闭",
                //         CONTENT: "根据湖南省事业单位工作人员培训相关规定，您需要先到管理平台hnxxpt.zgzjzj.net进行注册才可以选课学习。",
                //         BACK_SUBMIT: () => {
                //            // window.open("https://hnxxpt.zgzjzj.net/register?type=0", "_self")
                //         }
                //     })
                //     break;
                  case 7031:
                    $zj.alert({
                        TITLE: "提示",
                        SHOW_CLOSE: false,
                        SHOW_CANCEL: false,
                        BTN_SUBMIT: "确定",
                        BTN_CANCEL: "关闭",
                        CONTENT: "根据柳州市事业单位工作人员培训相关规定，您需要先到管理平台lzxxpt.zgzjzj.net进行注册才可以选课学习。",
                        BACK_SUBMIT: () => {
                            // window.open("https://lzxxpt.zgzjzj.net/register?type=0", "_self")
                        }
                    })
                    break;
            //领取优惠券errcode
            case 1604:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "优惠卷停止发放",
                })
                break;
            case 3500:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划培训计划推荐列表获取失败",
                })
                break;
            case 3501:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "用户添加计划失败",
                })
                break;
            case 3500:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划培训计划推荐列表获取失败",
                })
                break;
            case 3507:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "删除用户计划内课程失败",
                })
                break;
            case 3503:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "用户添加计划课程失败",
                })
                break;
            case 3511:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "检查计划内课程重复失败",
                })
                break;
            case 3510:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "不符合需求设定场景，不允许空包激活",
                })
                break;
            case 510:
                break;
            case 3509:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "空包激活失败",
                })
                break;
            case 3600:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "获取用户计划添加课程列表异常",
                })
                break;
            case 3503:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "用户添加计划课程失败",
                })
                break;
            case 3518:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划已过期，不允许激活",
                })
                break;
            case 3510:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "不允许激活",
                })
                break;
            case 3519:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划未选课，不允许激活",
                })
                break;
            case 3517:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "选课激活失败",
                })
                break;
            //线下考试报名部分开始
            case 958:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "截止时间一天内不可报名",
                })
                break;
            case 950:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考场报名次数已用完，不能报名",
                })
                break;
            case 959:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试三天前不允许取消报名！",
                })
                break;
            case 956:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "准考证生成失败",
                })
                break;
            case 955:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "报名重复，请核实考场信息",
                })
                break;
            case 954:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "已报名同计划下的同一课程",
                })
                break;
            case 960:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划已合格，不能报名",
                })
                break;
            case 952:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划下的课程未合格，不能报名",
                })
                break;
            case 961:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "已报名其他考场，不能报名",
                })
                break;

            //线下考试报名部分结束
            case 1501:
                // $zj.alert({
                //     TITLE: "提示",
                //     CONTENT: "考试卡卡号不存在",
                // })
                break;
            case 1001:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "查询失败"
                })
                break;
            case 897:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "用户不存在"
                })
                break;
            case 956:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `准考证待生成`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1601:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券不存在`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1602:
               $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠规则不存在`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1603:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券发放规则不匹配`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1604:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券停止发放`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1603:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券发放完毕`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 3523:
               $zj.alert({
                    TITLE: "提示",
                    CONTENT: `获取列表失败`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1006:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `手机号格式错误`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 513:
               $zj.alert({
                    TITLE: "提示",
                    CONTENT: `无访问权限`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 925:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `证书已申请`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 926:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `成绩不合格`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1505:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试卡模板不存在"
                });
                break;
            case 1506:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试卡不存在"
                });
                break;
            // case 1507:
            //     $zj.alert({
            //         TITLE: "提示",
            //         CONTENT: "此证书不允许学院申请"
            //     });
            //     break;
            case 3512:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划存在作弊不能申请证书"
                });
                break;
            case 3513:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划规则不存在"
                });
                break;
            case 3514:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划模板不存在"
                });
                break;
            case 3506:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划与课程未关联"
                });
                break;
            case 958:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '截止时间一天内不可报名',
                })
                break;
            case 950:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户报名考场达到上限',
                })
                break;
            case 955:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户已报名此考场',
                })
                break;
            case 954:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户已报名同计划下的同一课程',
                })
                break;
            case 961:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户已报名考场',
                })
                break;
            case 952:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户计划下的课程未合格，不能报名',
                })
                break;
            case 960:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户计划已合格，不能报名',
                })
                break;
            case 962:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该用户激活的计划里没有此课程',
                })
                break;
            case 963:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该考场报名人数已达上限',
                })
                break;
            case 2505:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该课程在购物车中已存在',
                })
                break;
            case 2516:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该地区课程不允许购买',
                })
                break;
            case 2517:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '当前课程已经下架',
                })
                break;
            case 2531:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '当前商品课时与精品系数超过可购买的限制',
                })
                break;
            case 3500:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '计划培训计划推荐列表获取失败',
                })
                break;
            case 3501:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户添加计划失败',
                })
                break;
            case 3503:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户添加计划课程失败',
                })
                break;
            case 3507:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '删除用户计划内课程失败',
                })
                break;
            case 3509:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '空包激活失败',
                })
                break;
            case 3510:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '不符合需求设定场景，不允许空包激活',
                })
                break;
            case 3511:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '检查计划内课程重复失败',
                })
                break;
            case 3517:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '选课激活失败',
                })
                break;
            case 3518:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '计划已过期，不允许激活',
                })
                break;
            case 3519:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '计划未选课，不允许激活',
                })
                break;

            case 3520:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您当前无权限激活该计划！',
                })
                break;
            case 3521:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您已在该地区购买过相同的计划，无法再次购买',
                })
                break;
            case 3527:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您选择的课程不符合计划要求，请重新选择课程！',
                })
                break;
            case 3507:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '删除用户计划内课程失败',
                })
                break;
            case 3600:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '获取用户计划添加课程列表异常',
                })
                break;
            case 3606:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '课程信息已变更，请联系客服为您解决！客服电话：4008-434-678',
                })
                break;
            case 2520:
                $zj.alert({
                    TITLE: "温馨提示",
                    CONTENT: '该课程已经添加到计划中,请联系客服 电话:4008-434-678',
                })
                break;
            case 2500:
                $zj.alert({
                    TITLE: "温馨提示",
                    CONTENT: '通过该订单id没有找到记录',
                })
                break;
            case 2501:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已经开具电子发票，不符合退款申请的条件',
                })
                break;
            case 2502:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务支付时间已经超过90天了不能退款',
                })
                break;
            case 2503:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已经学习过了，不符合退款申请的条件',
                })
                break;
            case 2514:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已经产生观看记录，不符合退款申请的条件',
                })
                break;
            case 2513:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已有学习记录，不符合退款申请的条件',
                })
                break;






            case 2511:
                $zj.alert({

                    CONTENT: '订单计划下没有课程',
                })
                break;
            case 2521:
                $zj.alert({

                    CONTENT: '当前计划下的课程仍未观看，不允许再次购买',
                })
                break;
            case 2525:
                $zj.alert({

                    CONTENT: '当前计划已经被删除，不可购买',
                })
                break;
            case 2535:
                $zj.alert({

                    CONTENT: '当前计划已经申请退款不允许再次添加课程',
                })
                break;
            case 2523:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单正在申请开发票,不允许退款',
                })
                break;
            case 2355:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单退款需要后台人员帮助退款到银行卡',
                })
                break;
            case 2524:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单已经开通集体票,不允许退款',
                })
                break;
            case 2529:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单已经申请退款了,不允许退款',
                })
                break;
            case 511:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '服务繁忙，请稍后重试',
                })
                break;
            case 577:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: error,
                })
                break;
            case 1356:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '此身份证已注册',
                })
                break;
            case 1359:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '此手机号码已注册,请更换其他手机号码',
                })
                break;
            case 1357:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '此邮箱已注册',
                })
                break;
            case 7006:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '验证码错误',
                })
                break;
            /*




            杨峰 新增 errcode码






            */
            case 956:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `准考证待生成`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1601:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券不存在`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1602:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠规则不存在`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1603:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券发放规则不匹配`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1604:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券停止发放`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1603:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `优惠券发放完毕`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 3523:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `获取列表失败`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1006:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `手机号格式错误`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 513:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `无访问权限`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 925:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `证书已申请`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 926:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: `成绩不合格`,
                    SHOW_CLOSE: true,
                    SHOW_CANCEL: true,
                    BTN_CANCEL: "取消",
                    BTN_SUBMIT: "确定"
                });
                break;
            case 1505:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试卡模板不存在"
                });
                break;
            case 1506:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "考试卡不存在"
                });
                break;
            case 1507:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "此证书不允许学员申请"
                });
                break;
            case 3512:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划存在作弊不能申请证书"
                });
                break;
            case 3513:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划规则不存在"
                });
                break;
            case 3514:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划模板不存在"
                });
                break;
            case 3506:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划与课程未关联"
                });
                break;
            case 958:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '截止时间一天内不可报名',
                })
                break;
            case 950:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户报名考场达到上限',
                })
                break;
            case 955:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户已报名此考场',
                })
                break;
            case 954:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户已报名同计划下的同一课程',
                })
                break;
            case 961:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户已报名考场',
                })
                break;
            case 952:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户计划下的课程未合格，不能报名',
                })
                break;
            case 960:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户计划已合格，不能报名',
                })
                break;
            case 962:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该用户激活的计划里没有此课程',
                })
                break;
            case 963:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该考场报名人数已达上限',
                })
                break;
            case 2505:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该课程在购物车中已存在',
                })
                break;
            case 2516:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '该地区课程不允许购买',
                })
                break;
            case 2517:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '当前课程已经下架',
                })
                break;
            case 2531:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '当前商品课时与精品系数超过可购买的限制',
                })
                break;
            case 3500:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '计划培训计划推荐列表获取失败',
                })
                break;
            case 3501:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户添加计划失败',
                })
                break;
            case 3503:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '用户添加计划课程失败',
                })
                break;
            case 3507:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '删除用户计划内课程失败',
                })
                break;
            case 3509:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '空包激活失败',
                })
                break;
            case 3510:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '不符合需求设定场景，不允许空包激活',
                })
                break;
            case 3511:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '检查计划内课程重复失败',
                })
                break;
            case 3517:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '选课激活失败',
                })
                break;
            case 3518:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '计划已过期，不允许激活',
                })
                break;
            case 3519:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '计划未选课，不允许激活',
                })
                break;

            case 3520:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您当前无权限激活该计划！',
                })
                break;
            case 3521:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您已在该地区购买过相同的计划，无法再次购买',
                })
                break;
            case 3527:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '您选择的课程不符合计划要求，请重新选择课程！',
                })
                break;


            case 2520:
                $zj.alert({
                    TITLE: "温馨提示",
                    CONTENT: '该课程已经添加到计划中,请联系客服 电话:4008-434-678',
                })
                break;
            case 2500:
                $zj.alert({
                    TITLE: "温馨提示",
                    CONTENT: '通过该订单id没有找到记录',
                })
                break;
            case 2501:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已经开具电子发票，不符合退款申请的条件',
                })
                break;
            case 2502:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务支付时间已经超过90天了不能退款',
                })
                break;
            case 2503:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已经学习过了，不符合退款申请的条件',
                })
                break;
            case 2514:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已经产生观看记录，不符合退款申请的条件',
                })
                break;
            case 2513:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！十分遗憾，您申请退款的商品或服务已有学习记录，不符合退款申请的条件',
                })
                break;
            case 2523:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单正在申请开发票,不允许退款',
                })
                break;
            case 2355:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单退款需要后台人员帮助退款到银行卡',
                })
                break;
            case 2524:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单已经开通集体票,不允许退款',
                })
                break;
            case 2529:
                $zj.alert({
                    TITLE: "退款失败",
                    CONTENT: '您好！当前订单已经申请退款了,不允许退款',
                })
                break;
            // case 6007:
            //     $zj.alert({
            //         TITLE: "提示",
            //         CONTENT: '此考试卡已过期，请联系客服',
            //     })
            //     break;





            /*


            先放着 未去重


            */





            case 1001:
                // $zj.alert({
                //     TITLE: "提示",
                //     CONTENT: "身份证号格式错误",
                // })
                break;
            case 1502:
                // $zj.alert({
                //     TITLE:"提示",
                //     CONTENT:"考试卡密码不正确"
                // })
                break;
            case 1503:
                // $zj.alert({
                //     TITLE:"提示",
                //     CONTENT:"考试卡已被激活"
                // })
                break;
            case 1504:
                // $zj.alert({
                //     TITLE:"提示",
                //     CONTENT:"未购买该考试卡"
                // })
                break;
            case 2606:
                break;
            case 3540:
                break;
            case 3506:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划与课程未关联"
                })
                break;
            case 3515:
                break;
            case 3514:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划模板不存在"
                })
                break;
            case 3513:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划规则不存在"
                })
                break;
            case 3512:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "计划存在作弊不能申请证书"
                })
                break;
            case 2534:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: '当前课程不允许购买',
                })
                break;
            case 6414:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "您还未报名该课程！点击下方按钮赶快开始学习吧～",
                    BTN_SUBMIT: "报名学习",
                });
                break;
            case 6101:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: error
                });
                break;
            case 6102:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: error
                });
                break;
            case 6415:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "直播尚未开始"
                });
                break;
            case 2015:
                break;
            case 404:
                break;
            case 400:
                break;
            case 502:
                break;
            case 504:
                break;
            case 99995:
                break;
            case 99996:
                break;
            case 99997:
                break;
            case 99998:
                break;
            case 99999:
                break;
            case 2017:
                break;
            case 2018:
                break;
            case 925:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "证书已申请"
                })
                break;

            case 710:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: "根据code查字典项接口没传code"
                })
                break;

            default:
                $zj.alert({
                    TITLE: "提示",
                    CONTENT: error,
                })
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/errcode.js